import { api } from "../../utils/api";

export async function getCostCenter() {
  try {
    const response = await api.get('/cost-center');
    return response.data;
  } catch (error) {
    throw error;
  }
}